import * as React from 'react'
import { motion } from 'framer-motion'
import { Box, SxProps } from '@mui/material'
import { useAnimationStyles } from 'src/Libs/live-view'
import EnergyFlowIndicatorSvg from './EnergyFlowIndicatorSvg'

export interface ArrowSvgProps {
  transform: string
  direction?: 'in' | 'out'
  doRotateBy180Deg?: boolean
  sx?: SxProps
}

const BottomArrowSvg: React.FC<ArrowSvgProps> = ({ direction, transform, doRotateBy180Deg = false, sx }) => {
  const { classes, cx } = useAnimationStyles({ direction })

  return (
    <Box sx={{ position: 'relative', transform, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="52" viewBox="0 0 15 52" fill="none">
        <g id="livevalue_arrows">
          <motion.g id="line">
            <motion.path id="Vector 8" d="M7.50024 50L7.50025 25.6976L7.50025 0.999999" stroke="#A4AAAE" strokeWidth="2" strokeLinecap="round" />
          </motion.g>
          {direction === 'out' && (
            <g id="arrow_out_bottom_arrow">
              <path
                d="M0.292834 45.2085L0.224471 45.1332C-0.0960654 44.7404 -0.0733497 44.1604 0.292834 43.7943C0.659018 43.4281 1.239 43.4054 1.63178 43.7259L1.70705 43.7943L8.20566 50.2929C8.59619 50.6834 8.59619 51.3166 8.20566 51.7071C7.81514 52.0976 7.18197 52.0976 6.79145 51.7071L0.292834 45.2085Z"
                fill="#A4AAAE"
              />
              <path
                d="M13.2935 43.793L13.3695 43.724C13.7623 43.4038 14.3417 43.427 14.7078 43.793C15.0983 44.1836 15.0983 44.8167 14.7078 45.2072L8.20777 51.7072C7.81724 52.0978 7.18408 52.0978 6.79355 51.7072C6.40303 51.3167 6.40303 50.6835 6.79355 50.293L13.2935 43.793Z"
                fill="#A4AAAE"
              />
            </g>
          )}
          {direction === 'in' && (
            <g id="arrow_in_bottom_arrow">
              <path
                d="M14.7079 6.79177L14.7763 6.86704C15.0968 7.25982 15.0741 7.8398 14.7079 8.20599C14.3417 8.57217 13.7617 8.59488 13.369 8.27435L13.2937 8.20599L6.79507 1.70737C6.40455 1.31685 6.40455 0.68368 6.79507 0.293156C7.18559 -0.097368 7.81876 -0.0973679 8.20928 0.293156L14.7079 6.79177Z"
                fill="#A4AAAE"
              />
              <path
                d="M1.70718 8.20722L1.63123 8.27627C1.23845 8.59645 0.659025 8.57327 0.292971 8.20722C-0.0975532 7.81669 -0.0975531 7.18353 0.292971 6.793L6.79297 0.293006C7.18349 -0.0975177 7.81666 -0.0975186 8.20718 0.293005C8.5977 0.68353 8.5977 1.31669 8.20718 1.70722L1.70718 8.20722Z"
                fill="#A4AAAE"
              />
            </g>
          )}
        </g>
      </svg>
      {!!direction && (
        <EnergyFlowIndicatorSvg
          className={cx(classes.directionIndicator, classes.sideArrowAnimation)}
          doRotateBy180Deg={doRotateBy180Deg}
          direction={direction}
        />
      )}
    </Box>
  )
}

export default BottomArrowSvg
